export { default as ProductPage } from "./View"; // export { default as ProductPage } from "./ViewAttribute";